import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SendMailsComponent } from 'src/app/components/shared/dialogs/send-mails/send-mails.component';
import { SweetalertService } from 'src/app/services/sweetalert/sweetalert.service';
import { TransportorSocietyService } from 'src/app/services/transportor-society/transportor-society.service';
//import { TransportorsService } from 'src/app/services/transportors/transportors.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-society',
  templateUrl: './contract-society.component.html',
  styleUrls: ['./contract-society.component.css'],
})
export class ContractSocietyComponent implements OnInit {
  closeResult: string;

  idSociety: any;
  contractSociety: any;

  loading = true;
  isSaved: Boolean = true;

  form: FormGroup;

  countries: any[] = [
    'Allemagne',
    'Angleterre',
    'Autriche',
    'Belgique',
    'Bulgarie',
    'Chypre',
    'Croatie',
    'Danemark',
    'Espagne',
    'Estonie',
    'Finlande',
    'France',
    'Grèce',
    'Hongrie',
    'Irlande',
    'Italie',
    'Lettonie',
    'Lituanie',
    'Luxembourg',
    'Malte',
    'Pays-Bas',
    'Pologne',
    'Portugal',
    'République tchèque',
    'Roumanie',
    'Slovaquie',
    'Slovénie',
    'Suisse',
    'Suède',
  ];

  logisticParams: any[] = [
    '% age volume (Calculé lors de la constitution de la remorque)',
    'Volume réel',
    'Total Cout enlèvement (Calculé lors de la constitution de la remorque)',
    'Fixe (paramètre  égal à 1)',
  ];

  transportorTypes: any[] = [
    { label: 'complet', title: 'Complet' },
    { label: 'grouping', title: 'Grouping' },
    { label: 'combined', title: 'Combined' },
  ];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private sweetalert: SweetalertService,
    private service: TransportorSocietyService,
    private translate: TranslateService
  ) {
    this.form = fb.group({
      freightRates: fb.array([]),
      offers: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      // console.log(params)
      this.idSociety = params.society;
      // this._fetchTransportor();
      this.initContractSociety();
    });
  }

  async initContractSociety() {
    this.freightRates.clear();

    await this.getContractSociety();

    this.loading = false;
  }

  getContractSociety() {
    return new Promise((slv) => {
      this.service.getContractSociety(this.idSociety).then(async (res: any) => {
        // console.log("getContractSociety : ")
        // console.log(res)
        if (res && res.response && res.data) {
          this.mappingFreightRateGroup(res.data);
        } else {
          this.addNewFreightRateGroup();
        }
        slv(true);
      });
    });
  }

  get freightRates(): FormArray {
    return this.form.get('freightRates') as FormArray;
  }

  mappingFreightRateGroup(data: any) {
    this.freightRates.clear();

    data.freightRates.forEach((item: any) => {
      this.freightRates.push(
        this.fb.group({
          country: [item.country, [Validators.required]],
          minimum: this.fb.group({
            max: [item.minimum.max, [Validators.required]],
            value: [item.minimum.value, [Validators.required]],
          }),
          ranges: this.fb.array(this.mappingRangesGroup(item.ranges)),
          maximum: [item.maximum, [Validators.required]],
        })
      );
    });

    if (data.offers.length) this.setOffers(data.offers);
  }
  mappingRangesGroup(ranges: any) {
    var theRanges = [];

    ranges.forEach((range: any) => {
      theRanges.push(
        this.fb.group({
          min: [range.min, [Validators.required]],
          max: [range.max, [Validators.required]],
          value: [range.value, [Validators.required]],
        })
      );
    });

    return theRanges;
  }

  addNewFreightRateGroup() {
    this.freightRates.push(
      this.fb.group({
        country: ['', [Validators.required]],
        minimum: this.fb.group({
          max: ['', [Validators.required]],
          value: ['', [Validators.required]],
        }),
        ranges: this.fb.array([
          this.fb.group({
            min: ['', [Validators.required]],
            max: ['', [Validators.required]],
            value: ['', [Validators.required]],
          }),
        ]),
        maximum: ['', [Validators.required]],
      })
    );
  }
  deleteFreightRateGroup(index: number) {
    if (this.form.value.freightRates.length > 1) {
      this.freightRates.removeAt(index);
    }
  }
  getRanges(itemIndex: number) {
    return (this.freightRates.at(itemIndex) as FormGroup).get(
      'ranges'
    ) as FormArray;
  }

  addRanges(itemIndex: number) {
    const range = this.fb.group({
      min: '',
      max: '',
      value: '',
    });

    this.getRanges(itemIndex).push(range);
  }

  deleteRangeGroup(i: number, j: number) {
    var ranges = this.getRanges(i);
    // console.log(ranges)

    if (ranges.value.length > 1) {
      ranges.removeAt(j);
    }
  }

  // === Getters utiles ===
  get offersFA(): FormArray {
    return this.form.get('offers') as FormArray;
  }
  // Crée un FormGroup pour une offre
  private newOffer(data?: Partial<any>) {
    return this.fb.group({
      plateform: [data?.plateform ?? '', [Validators.required]],
      type: [data?.type ?? '', [Validators.required]],
      labels: [data?.labels ?? '', [Validators.required]],
      logistic_param: [data?.logistic_param ?? '', [Validators.required]],
      value: [data?.value ?? null, [Validators.required, Validators.min(0)]],
      min_level: [data?.min_level ?? null],
      max_level: [data?.max_level ?? null],
      min: [data?.min ?? null],
      max: [data?.max ?? null],
    });
  }

  // Ajouter une offre vide (ou avec valeurs)
  addOffer(data?: Partial<any>): void {
    this.offersFA.push(this.newOffer(data));
  }

  // Retirer une offre
  removeOffer(index: number): void {
    // if (this.offersFA.length === 1) {
    //   return;
    // }
    this.offersFA.removeAt(index);
  }

  setOffers(offers: any): void {
    const arr = offers?.map((o) => this.newOffer(o)) ?? [];
    this.form.setControl('offers', this.fb.array(arr));
  }

  onChangeOfferType(event, i) {
    // console.log(event.target.value);
    const type = (event.target as HTMLSelectElement).value;
    const group = this.offersFA.at(i) as FormGroup;

    const empty = type === 'transport' ? [] : '';
    const labelsCtrl = group.get('labels');

    labelsCtrl?.setValue(empty);
    labelsCtrl?.markAsPristine();
    labelsCtrl?.markAsUntouched();
    labelsCtrl?.updateValueAndValidity({ emitEvent: false });
  }

  addContractSociety() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    // console.log(this.form.value.freightRates)
    // var isValidate = this.freightRateNotEmpty(this.form.value.freightRates)
    // if (!isValidate) {
    //   this.isSaved = isValidate
    //   alert("Les valeurs du contrat de la société est invalide");
    // } else {
    var data = {
      idSociety: this.idSociety,
      freightRates: this.form.value.freightRates,
      offers: this.form.value.offers,
    };
    // console.log(data)
    this.service.saveContractSociety(data).then(async (res: any) => {
      // console.log("resssssssss : ")
      // console.log(res)
      if (res && res.response) {
        await this.sweetalert
          .alertSuccess(this.translate.instant('data.save_contract_alert'))
          .then((result: any) => {
            if (result.isConfirmed) {
              this.mappingFreightRateGroup(res.data);
            }
          });
      } else {
        await this.sweetalert.alertProblem(res?.msg).then((result: any) => {
          if (result.isConfirmed) {
            this.initContractSociety();
          }
        });
      }
    });
    // }
  }

  open(content) {
    this.modalService.open(content).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  // openLarge(content) {
  //   this.modalService.open(content, {
  //     size: 'lg'
  //   });
  // }
  // openLarge() {
  //   const modalRef = this.modalService.open(SendMailsComponent, { size: 'lg' });
  //   // modalRef.componentInstance.close.subscribe((reason: string) => {
  //   //   console.log(reason)
  //   //   // Gérer la fermeture ici si nécessaire
  //   // });
  // }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // freightRateNotEmpty(freightRates: any) {
  //   if (freightRates.length == 0)
  //     return false

  //   for (var i = 0; i < freightRates.length; i++) {
  //     if (freightRates[i].country == null || freightRates[i].country == ""

  //       || freightRates[i].minimum == null
  //       || freightRates[i].minimum.max == null || freightRates[i].minimum.max == ""
  //       || freightRates[i].minimum.value == null || freightRates[i].minimum.value == ""

  //       || !this.checkRanges(freightRates[i].ranges)
  //       || freightRates[i].maximum == null || freightRates[i].maximum == "")
  //       return false
  //   }
  //   return true
  // }
  // checkRanges(ranges: any[]) {
  //   for (var i = 0; i < ranges.length; i++) {
  //     if (!this.checkRange(ranges[i]))
  //       return false
  //   }
  //   return true
  // }
  // checkRange(range: any) {
  //   if (range?.min != null && range?.min?.toString() != ""
  //     && range?.max != null && range?.max?.toString() != ""
  //     && range?.value != null && range?.value?.toString() != "")
  //     return true
  //   else
  //     return false
  // }
  // checkValue(item: any) {
  //   if (item == null || (item != null && item == ""))
  //     return true
  //   else
  //     return false
  // }
}
